import React from 'react';

const PhoneSlide = ({ text }) => {
    return (
        <div className="h-screen flex items-center justify-center px-4 sm:px-8">
            <div className="relative w-[50%] max-w-lg">
                {/* Blue shadow box behind */}
                <div className="absolute inset-0 bg-blue-700  translate-x-3 translate-y-3 z-0" />

                {/* Foreground white text box */}
                <div className="relative z-10 bg-white border-2 border-blue-700 px-10 py-8 text-left shadow-lg text-md sm:text-lg  leading-relaxed">
                    {text}
                </div>
            </div>
        </div>
    );
};

export default PhoneSlide;
